module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-5.4e558b2f.svg";